import { useEffect } from "react";
const WebViewParam = "webView";
const ImbaWebViewParam = "imbaWebView";
const WebViewBodyClass = "web-view";
const initializeWebView = () => {
  const urlParam = new URLSearchParams(window.location.search);
  const turnOnWebView = urlParam.get(WebViewParam) === "true";
  const turnOnImbaWebView = urlParam.get(ImbaWebViewParam) === "true";
  if (turnOnWebView) {
    document.body.classList.add(WebViewBodyClass);
  }
  return {
    turnOnWebView,
    turnOnImbaWebView
  };
};
const webViewStatus = () => window.webViewEnabled;
const imbaWebViewStatus = () => window.imbaWebViewEnabled;
const useWebView = () => {
  useEffect(() => {
    const { turnOnWebView, turnOnImbaWebView } = initializeWebView();
    if (turnOnWebView) {
      window.webViewEnabled = turnOnWebView;
    }
    if (turnOnImbaWebView) {
      window.imbaWebViewEnabled = turnOnImbaWebView;
    }
  }, []);
};
export {
  ImbaWebViewParam,
  WebViewParam,
  imbaWebViewStatus,
  initializeWebView,
  useWebView,
  webViewStatus
};
